<template>
  <v-container
    grid-list-xs
    fluid
    class="pa-2"
  >
    <v-layout
      row
      wrap
    >
      <v-container
        grid-list-md
        fluid
        class="pa-0"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm6
          >
            <v-card class="max-shadow">
              <v-card-title>
                <div class="title-2">
                  Billing
                </div>
                <v-spacer />
                <v-card-actions>
                  <v-btn
                    color="primary"
                    flat
                    @click="saveBillingSettings"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-divider />
              <v-form ref="billingForm">
                <v-subheader>
                  GST
                </v-subheader>
                <div class="px-3">
                  <v-text-field
                    v-model="billingSettings.GSTIN"
                    outline
                    :rules="[(v) => {return validateGSTIN(v);}]"
                    label="GST Indentification Number"
                  />
                </div>
                <v-subheader>Address</v-subheader>
                <div class="px-3 pb-3">
                  <v-text-field
                    v-model="billingSettings.address.company"
                    :rules="[v => !!v || 'Company is required']"
                    label="Company"
                    required
                  />
                  <v-text-field
                    v-model="billingSettings.address.line1"
                    :rules="[v => !!v || 'Address Line 1 is required']"
                    label="Address Line 1"
                    required
                  />
                  <v-text-field
                    v-model="billingSettings.address.line2"
                    label="Address Line 2"
                  />
                  <v-text-field
                    v-model="billingSettings.address.city"
                    :rules="[v => !!v || 'City is required']"
                    label="City"
                    required
                  />
                  <v-autocomplete
                    v-model="billingSettings.address.state"
                    :items="states"
                    :search-input.sync="search"
                    :rules="[v => !!v || 'State is required']"
                    item-text="name"
                    item-value="name"
                    label="State"
                    required
                    chips
                    clearable
                  >
                    <template slot="no-data">
                      <v-list-tile>
                        <v-list-tile-title>Not Found</v-list-tile-title>
                      </v-list-tile>
                    </template>
                    <template
                      slot="seletion"
                      slot-scope="{item, selected}"
                    >
                      <v-chip :selected="selected">
                        <span v-text="item.name" />
                      </v-chip>
                    </template>
                    <template
                      slot="item"
                      slot-scope="{item}"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ item.name }} - {{ item.code }}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                  <v-text-field
                    v-model="billingSettings.address.pincode"
                    :rules="[v => !!v || 'Pincode is required']"
                    label="Pincode"
                    mask="######"
                    required
                  />
                </div>
              </v-form>
            </v-card>
          </v-flex>
          <v-flex
            xs12
            sm6
          >
            <v-card class="max-shadow">
              <v-card-title>
                <div class="title-2">
                  Company
                </div>
                <v-spacer />
                <v-card-actions>
                  <v-btn
                    color="primary"
                    flat
                    @click="saveCompanyName"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-divider />
              <v-form
                ref="companyForm"
                class="pa-2"
              >
                <v-text-field
                  v-model="companyName"
                  name="companyName"
                  label="Company Name"
                  outline
                />
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      :right="true"
      :timeout="4000"
      :top="true"
      :color="snackColor"
    >
      {{ snackText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { firestore } from '@/firebase';

export default {
  name: 'Company',
  data() {
    return {
      billingSettings: {
        GSTIN: null,
        address: {
          company: null,
          line1: null,
          line2: null,
          city: 'Noida',
          state: 'Uttar Pradesh',
          pincode: 201301
        }
      },
      search: '',
      states: [
        {
          code: 'AN',
          name: 'Andaman and Nicobar Islands'
        },
        {
          code: 'AP',
          name: 'Andhra Pradesh'
        },
        {
          code: 'AR',
          name: 'Arunachal Pradesh'
        },
        {
          code: 'AS',
          name: 'Assam'
        },
        {
          code: 'BR',
          name: 'Bihar'
        },
        {
          code: 'CG',
          name: 'Chandigarh'
        },
        {
          code: 'CH',
          name: 'Chhattisgarh'
        },
        {
          code: 'DH',
          name: 'Dadra and Nagar Haveli'
        },
        {
          code: 'DD',
          name: 'Daman and Diu'
        },
        {
          code: 'DL',
          name: 'Delhi'
        },
        {
          code: 'GA',
          name: 'Goa'
        },
        {
          code: 'GJ',
          name: 'Gujarat'
        },
        {
          code: 'HR',
          name: 'Haryana'
        },
        {
          code: 'HP',
          name: 'Himachal Pradesh'
        },
        {
          code: 'JK',
          name: 'Jammu and Kashmir'
        },
        {
          code: 'JH',
          name: 'Jharkhand'
        },
        {
          code: 'KA',
          name: 'Karnataka'
        },
        {
          code: 'KL',
          name: 'Kerala'
        },
        {
          code: 'LD',
          name: 'Lakshadweep'
        },
        {
          code: 'MP',
          name: 'Madhya Pradesh'
        },
        {
          code: 'MH',
          name: 'Maharashtra'
        },
        {
          code: 'MN',
          name: 'Manipur'
        },
        {
          code: 'ML',
          name: 'Meghalaya'
        },
        {
          code: 'MZ',
          name: 'Mizoram'
        },
        {
          code: 'NL',
          name: 'Nagaland'
        },
        {
          code: 'OR',
          name: 'Odisha'
        },
        {
          code: 'PY',
          name: 'Puducherry'
        },
        {
          code: 'PB',
          name: 'Punjab'
        },
        {
          code: 'RJ',
          name: 'Rajasthan'
        },
        {
          code: 'SK',
          name: 'Sikkim'
        },
        {
          code: 'TN',
          name: 'Tamil Nadu'
        },
        {
          code: 'TS',
          name: 'Telangana'
        },
        {
          code: 'TR',
          name: 'Tripura'
        },
        {
          code: 'UP',
          name: 'Uttar Pradesh'
        },
        {
          code: 'UK',
          name: 'Uttarakhand'
        },
        {
          code: 'WB',
          name: 'West Bengal'
        }
      ],
      companyName: null,
      snackbar: false,
      snackColor: 'success',
      snackText: ''
    };
  },
  mounted() {
    firestore
      .doc(`tenants/${this.$store.state.profile.cid}`)
      .get()
      .then(settings => {
        const billingSettings = settings.data().billingSettings;
        if (billingSettings) this.billingSettings = billingSettings;
        this.companyName = settings.data().companyName;
      });
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Admin Settings' });
  },
  methods: {
    validateGSTIN(val) {
      if (!val) {
        return true;
      }
      if (val && /^\w\d\S{13}$/.test(val)) {
        return true;
      }
      return 'Invalid GSTIN';
    },

    saveBillingSettings() {
      if (!this.$refs.billingForm.validate()) return;

      const formattedGSTIN = this.billingSettings.GSTIN
        ? this.billingSettings.GSTIN.toUpperCase()
        : null;

      this.billingSettings.GSTIN = formattedGSTIN;

      firestore
        .doc(`tenants/${this.$store.state.profile.cid}`)
        .update({
          billingSettings: this.billingSettings
        })
        .then(() => {
          this.snackText = 'Billing settings are saved';
          this.snackbar = true;
        })
        .catch(error => {
          this.snackColor = 'error';
          this.snackText = 'Error in saving billing settings are saved';
          this.snackbar = true;
          console.log(error);
        });
    },

    saveCompanyName() {
      if (!this.$refs.companyForm.validate()) return;

      firestore
        .doc(`tenants/${this.$store.state.profile.cid}`)
        .update({
          companyName: this.companyName
        })
        .then(() => {
          this.snackText = 'Company Name is saved';
          this.snackbar = true;
        })
        .catch(error => {
          this.snackColor = 'error';
          this.snackText = 'Error in saving Company Name';
          this.snackbar = true;
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
</style>